export default __webpack_public_path__ + "static/media/vietchaulogo_rounded.5194819c.png";